import { render, staticRenderFns } from "./RecievedRequests.vue?vue&type=template&id=2dcb6dc0&"
import script from "./RecievedRequests.vue?vue&type=script&lang=js&"
export * from "./RecievedRequests.vue?vue&type=script&lang=js&"
import style0 from "./RecievedRequests.vue?vue&type=style&index=0&id=2dcb6dc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports